function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg01D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.536,
    height: 26.536,
    viewBox: "0 0 26.536 26.536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "01d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14528",
    d: "M28.645 23.811a.8.8 0 0 1-.737-.492l-1.185-2.86a.8.8 0 0 1 1.473-.611l1.185 2.86a.8.8 0 0 1-.737 1.1zm9.146 22.082a.8.8 0 0 1-.737-.492l-1.185-2.86a.8.8 0 0 1 1.473-.611l1.185 2.86a.8.8 0 0 1-.737 1.1zm-17.636-7.306a.8.8 0 0 1-.305-1.534l2.86-1.185a.8.8 0 0 1 .611 1.473l-2.86 1.185a.8.8 0 0 1-.305.061zm22.081-9.146a.8.8 0 0 1-.305-1.534l2.86-1.185A.8.8 0 0 1 45.4 28.2l-2.86 1.185a.814.814 0 0 1-.304.057zm-5.631-5.631a.8.8 0 0 1-.736-1.1l1.185-2.86a.8.8 0 0 1 1.473.611l-1.185 2.86a.8.8 0 0 1-.737.49zm-9.146 22.083a.8.8 0 0 1-.736-1.1l1.185-2.86a.8.8 0 1 1 1.473.611L28.2 45.4a.8.8 0 0 1-.741.493zm-4.445-16.451a.792.792 0 0 1-.3-.061L19.85 28.2a.8.8 0 1 1 .611-1.473l2.86 1.185a.8.8 0 0 1-.306 1.534zm22.081 9.146a.792.792 0 0 1-.3-.061l-2.86-1.185a.8.8 0 0 1 .611-1.473l2.86 1.185a.8.8 0 0 1-.306 1.534z",
    transform: "translate(-19.357 -19.357)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14529",
    d: "M36.095 27.869a8.231 8.231 0 1 1-3.144.628 8.207 8.207 0 0 1 3.144-.628",
    transform: "translate(-22.83 -22.83)",
    style: {
      fill: "#ff8826"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01D);
export default __webpack_public_path__ + "static/media/01D.78377c17ea53207ebc7c99232b158d6e.svg";
export { ForwardRef as ReactComponent };